import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3595e5ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-page" }

import { ref } from 'vue'
import Person from './person/index.vue'
import Company from './company/user.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const active = ref('company')

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_tabs, {
      modelValue: active.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event)),
      class: "tabs"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "企业用户",
          name: "company"
        }, {
          default: _withCtx(() => [
            _createVNode(Company)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "个人用户",
          name: "person"
        }, {
          default: _withCtx(() => [
            _createVNode(Person)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})